import { Fragment } from 'react/jsx-runtime'
import { useLocation, useSearchParams } from 'react-router-dom'

export default function LocationBasedRemountComponent({
  children,
  stableParams
}: {
  children: React.ReactNode
  stableParams?: string[]
}) {
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const keyForRemount = stableParams
    ? stableParams.map((param) => searchParams.get(param) ?? '').join(' ')
    : location.search

  return <Fragment key={keyForRemount}>{children}</Fragment>
}
